"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedByType = exports.AppType = exports.Status = exports.DeploymentHostType = exports.PackageManager = exports.DevelopmentTool = void 0;
var DevelopmentTool;
(function (DevelopmentTool) {
    DevelopmentTool["UNKNOWN_TEMPLATE_TYPE"] = "UNKNOWN_TEMPLATE_TYPE";
    DevelopmentTool["DEV_CENTER"] = "DEV_CENTER";
    DevelopmentTool["BLOCKS"] = "BLOCKS";
    DevelopmentTool["CLI"] = "CLI";
})(DevelopmentTool = exports.DevelopmentTool || (exports.DevelopmentTool = {}));
var PackageManager;
(function (PackageManager) {
    PackageManager["UNKNOWN_PACKAGE_MANAGER"] = "UNKNOWN_PACKAGE_MANAGER";
    PackageManager["NPM"] = "NPM";
    PackageManager["YARN"] = "YARN";
})(PackageManager = exports.PackageManager || (exports.PackageManager = {}));
var DeploymentHostType;
(function (DeploymentHostType) {
    DeploymentHostType["UNKNOWN_DEPLOYMENT_HOST_TYPE"] = "UNKNOWN_DEPLOYMENT_HOST_TYPE";
    DeploymentHostType["VERCEL"] = "VERCEL";
    DeploymentHostType["NETLIFY"] = "NETLIFY";
})(DeploymentHostType = exports.DeploymentHostType || (exports.DeploymentHostType = {}));
var Status;
(function (Status) {
    Status["ACTIVE"] = "ACTIVE";
    Status["DEPRECATED"] = "DEPRECATED";
    Status["ARCHIVED"] = "ARCHIVED";
})(Status = exports.Status || (exports.Status = {}));
var AppType;
(function (AppType) {
    /** A Regular app entity - used to installed on sites */
    AppType["SITE_APP"] = "SITE_APP";
    /** represents an account API KEY to access wix services */
    AppType["API_KEY"] = "API_KEY";
    /** represents an app developed for Velo editor */
    AppType["VELO_APP"] = "VELO_APP";
    /** deprecated. Use private boolean instead */
    AppType["PRIVATE_APP"] = "PRIVATE_APP";
    /** represents an External Headless (3rd party) App that has access to Wix Public Services */
    AppType["HEADLESS"] = "HEADLESS";
})(AppType = exports.AppType || (exports.AppType = {}));
var CreatedByType;
(function (CreatedByType) {
    CreatedByType["USER"] = "USER";
    CreatedByType["APP"] = "APP";
})(CreatedByType = exports.CreatedByType || (exports.CreatedByType = {}));
//# sourceMappingURL=types.impl.js.map